import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch, AppState, store } from 'store'
import { TFieldValues, TFieldsObjectNames } from 'models/Form/FieldsModels'
import { BasicInfoFieldsNames } from 'FormDefinitions/BasicInfoForm/BasicInfoFields'
import { ValidationError } from 'yup'
import { clearFieldValidateError, setFieldValidateError } from 'store/FormSlice/FormSlice'
import { FormNames, IFormDefinition } from 'models/Form/FormModels'
import { UseFormHandlersReturnProps } from '../AppFormProps'
import { IAppConsentsModel } from 'service/SettingsService/SettingsServiceModels'
import { appConsentsValidateAll } from 'store/ConsentsSlice/ConsentsSlcie'

const useFormHandlers = (): UseFormHandlersReturnProps => {

   const dispatch = useDispatch<AppDispatch>()
    
   const handleValidateSingleField = React.useCallback((fieldName: TFieldsObjectNames, fieldValue: TFieldValues, fieldValidationFunction: any): boolean => {
      switch(fieldName){
         case BasicInfoFieldsNames.ConfirmEmail: { // Specjalna customowa walidacja, potrzebująca dodatkowych parametrów i specjalnej obsługi.
            try {
                  const currentState = store.getState()
                  const emailFieldValue = currentState.formState[BasicInfoFieldsNames.Email].value
                  fieldValidationFunction(fieldValue, emailFieldValue)
                  dispatch(clearFieldValidateError(fieldName))

                  return true // Walidacja przeszła
            } 
            catch (error: unknown) {
               if (error instanceof ValidationError) {
                  dispatch(setFieldValidateError({ fieldName, validationError: error.message }))

                  return false // Walidacja nie przeszła
               }
            }

            break;
         }
         default: {
            try {
               if(fieldValidationFunction !== undefined) {
                  fieldValidationFunction.validateSync(fieldValue)
                  dispatch(clearFieldValidateError(fieldName))
   
                  return true // Walidacja przeszła
               }
               else {
                  return true // Jeśli nie ma funkcji walidaującej, oznacza to że nie walidujemy danego pola, stąd bez sprawdzania uznajemy je za poprawne.
               }
            } 
            catch (error) {
               if (error instanceof ValidationError) {
                  dispatch(setFieldValidateError({ fieldName, validationError: error.message }))

                  return false // Walidacja nie przeszła
               }
            }
         }
      }

      return false
   }, [])

   const handleValidateForm = React.useCallback((form: IFormDefinition): boolean => {
      const currentForm = document.querySelector(`form[name='${form.name}']`) as HTMLFormElement
      const formData = new FormData(currentForm) //Tworzymy obiekt FormData dla obecnego formularza. Obiekt ten zawiera tablicę obiektów: {nazwaPola, wartośćPola}
      const validationResults = []
      
      for (const [fieldName, fieldObject ] of Object.entries(form.fields)) {
         const currentFieldValue = formData.get(fieldName) as TFieldValues // Pobieramy wartość obecnie rozpatrywanego pola z obiektu FormData     
         //Odpalamy walidację dla wszystkich kontrolek z obecnego formularza. Weryfikujemy czy użytkownik poprawnie uzupełnił cały formularz
         validationResults.push(handleValidateSingleField(fieldName as TFieldsObjectNames, currentFieldValue, fieldObject.validation))
      }

      return validationResults.every((validationResult: boolean) => validationResult === true) // Jeśli true - formularz przeszedł walidację i dane są poprawne
   }, [])

   const checkIsRequiredConsentsMarked = React.useCallback((appConsents: IAppConsentsModel[]) => {
      dispatch(appConsentsValidateAll())

      return appConsents.some(appConsent => appConsent.isRequired && !appConsent.isChecked)
   }, [])

   return {
      handleValidateSingleField,
      handleValidateForm,
      checkIsRequiredConsentsMarked
   }
}

export default useFormHandlers